import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { deleteApplication } from "MODULES/parts/actions/applications";
import {
  HIGHER_ASSEMBLY_APPLICATION,
  LOWER_ASSEMBLY_APPLICATION
} from "MODULES/parts/constants";
import { NoteTooltip as IconTooltip, Tag } from "MODULES/shared/components";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";

function ApplicationTag(props) {
  const { application, navToPart } = props;
  const clickableTag =
    application.type === HIGHER_ASSEMBLY_APPLICATION ||
    (application.type === LOWER_ASSEMBLY_APPLICATION &&
      application.applicable_uuid);

  const tierClass = getPartNumberColorClassNameByTierType(
    application.tier_type
  );

  if (clickableTag) {
    const onLabelClick = () => navToPart(application.applicable_uuid);
    return (
      <Tag
        {...props}
        addOn={
          application.sellable && (
            <IconTooltip
              className="m-r-5"
              note="In Stock"
              url="https://aero-zone-assets.s3.amazonaws.com/inventory.png"
            />
          )
        }
        label={application.label}
        onLabelClick={onLabelClick}
        className={tierClass}
      />
    );
  }

  return <Tag {...props} label={application.label} />;
}

ApplicationTag.propTypes = {
  application: PropTypes.instanceOf(Object).isRequired,
  navToPart: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  destroy: () =>
    dispatch(
      deleteApplication(ownProps.application.id, ownProps.application.part_id)
    ),
  navToPart: partId => dispatch(push(`/parts/${partId}`))
}))(ApplicationTag);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Applications/Application.jsx